
import {systemConfiguration} from "../../../src/CommonImports";
import  './../css/GRecentJobs.css';
import  './../css/GBrowsebycategory.css';
import  './../css/GSideBar.css';
import  './../css/GPostJob.css';
import  './../css/GMediaQuery.css';
import  './../css/Gtop.css';
import  './../css/GAnimetion.css';
import  './../css/GGraphicJob.css';
import  './../css/GFooter.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function GFooter(){

    const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
    const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';

    return (
<footer className="footer mt-20 ">
        <div className="container">
            <div className="row">
                <div className="col-md-4 col-sm-12">
                    <a href="#"><img alt="jobhub" src={mediaUrl+"jobhub-logo.svg?"+sasToken}/></a>
                    <div className="mt-20 mb-20">Jobhub is the heart of the design community and the best resource to discover and connect with designers and jobs worldwide.</div>
                </div>
				
				
               <div className="col-md-2 col-6 text-center">
				<h6>Company</h6>
				<ul className="menu-footer mt-40">
					<li><a href="#">About us</a></li>
					<li><a href="#">Our Team</a></li>
					<li><a href="#">Products</a></li>
					<li><a href="#">Contact</a></li>
				</ul>
			</div>

			<div className="col-md-2 col-6 text-center">
				<h6>Product</h6>
				<ul className="menu-footer mt-40">
					<li><a href="#">Feature</a></li>
					<li><a href="#">Pricing</a></li>
					<li><a href="#">Credit</a></li>
					<li><a href="#">FAQ</a></li>
				</ul>
			</div>

			<div className="col-md-2 col-6 text-center">
				<h6>Download</h6>
				<ul className="menu-footer mt-40">
					<li><a href="#">iOS</a></li>
					<li><a href="#">Android</a></li>
					<li><a href="#">Microsoft</a></li>
					<li><a href="#">Desktop</a></li>
				</ul>
			</div>

			<div className="col-md-2 col-6 text-center">
				<h6>Support</h6>
				<ul className="menu-footer mt-40">
					<li><a href="#">Privacy</a></li>
					<li><a href="#">Help</a></li>
					<li><a href="#">Terms</a></li>
					<li><a href="#">FAQ</a></li>
				</ul>
			</div>
            <div className="footer-bottom mt-50">
                <div className="row">
                  <div className="col-md-6 ">
                    Copyright ©2025 <a href="https://www.grastech3solutions.com/"><strong>Grastech3 IT Solutions Pvt Ltd.</strong></a>. All Rights Reserved
                  </div>
                  <div className="col-md-6 text-md-end text-start">            
                      <div className="footer-social">
                        <a href="#" className="icon-socials icon-facebook"></a>
                        <a href="#" className="icon-socials icon-twitter"></a>
                        <a href="#" className="icon-socials icon-instagram"></a>
                        <a href="#" className="icon-socials icon-linkedin"></a>
                      </div>                  
                  </div>
                </div>
              </div>
        </div>
        </div>
    </footer>
    )
}

    export default GFooter;